import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import axios from "axios";
import ForumSection from '@/views/newforum/section/ForumSection.vue';
import NewThreadForm from '@/views/newforum/thread/NewThreadForm.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/app',
        name: 'Landing',
        beforeEnter: checkLogged
    },
    {
        path: '/app/login',
        name: 'Login',
        component: () =>
            import('@/views/Login.vue'),
    },
    {
        path: '/app/home',
        name: 'Home',
        component: Home,
    },
    {
        path: '/app/store',
        name: 'Marketplace',
        component: () =>
            import('@/views/Store.vue')
    },
    {
        path: '/app/graficador-dinamico',
        component: () =>
            import('@/views/Stockchart/Base.vue'),
        children: [{
            path: '',
            name: 'Stockchart',
            component: () =>
                import('@/views/Stockchart/Stockchart.vue'),
        },
        {
            path: 'stockchart-table',
            name: 'StockchartTable',
            component: () =>
                import('@/views/Stockchart/Stockchart.vue'),
        }
        ],
    },
    {
        path: '/app/graficador-dinamico/:param1',
        component: () =>
            import('@/views/Stockchart/Base.vue'),
        children: [{
            path: '',
            name: 'Stockchart',
            component: () =>
                import('@/views/Stockchart/Stockchart.vue'),
        },
        {
            path: 'stockchart-table',
            name: 'StockchartTable',
            component: () =>
                import('@/views/Stockchart/Stockchart.vue'),
        }
        ],
    },
    {
        path: '/app/graficador-dinamico/:param1/:param2',
        component: () =>
            import('@/views/Stockchart/Base.vue'),
        children: [{
            path: '',
            name: 'Stockchart',
            component: () =>
                import('@/views/Stockchart/Stockchart.vue'),
        },
        {
            path: 'stockchart-table',
            name: 'StockchartTable',
            component: () =>
                import('@/views/Stockchart/Stockchart.vue'),
        }
        ],
    },
    {
        path: '/app/portfolio',
        name: 'Portfolio',
        beforeEnter: requirePortfolioAccess,
        component: () =>
            import('@/views/GestionCartera/PortfolioManager.vue')
    }, {
        path: '/app/portfolio/:param1/:param2',
        name: 'Portfolio',
        beforeEnter: requirePortfolioAccess,
        component: () =>
            import('@/views/Portfolio.vue')
    }, {
        path: '/app/artificial-inteligence',
        name: 'InteligenceArtificial',
        component: () =>
            import('@/views/InteligenceArtificial.vue')
    }, {
        path: '/app/twinsouls',
        name: 'TwinSouls',
        component: () =>
            import('@/views/TwinSouls.vue')
    }, {
        path: '/app/directionality',
        name: 'Directionality',
        component: () =>
        import ('@/views/Directionality.vue')
    },  {
        path: '/app/stoploss',
        name: 'StopLoss',
        component: () =>
            import('@/views/StopLoss.vue')
    }, {
        path: '/app/risk',
        name: 'Risk',
        component: () =>
            import('@/views/Risk.vue')
    }, {
        path: '/app/widgets',
        name: 'Widgets',
        component: () =>
            import('@/views/Widgets.vue')
    }, {
        path: '/app/exercises',
        name: 'Exercises',
        component: () =>
            import('@/views/Exercises.vue')
    }, {
        path: '/app/courses',
        name: 'Courses',
        component: () =>
            import('@/views/Courses.vue')
    }, {
        path: '/app/help-center',
        name: 'HelpCenter',
        component: () =>
            import('@/views/HelpCenter.vue')
    }, {
        path: '/app/broker-simulator',
        name: 'BrokerSimulator',
        component: () =>
            import('@/views/BrokerSimulator.vue')
    }, {
        path: '/app/pricing',
        name: 'Pricing',
        component: () =>
            import('@/views/Store.vue')
    }, {
        path: '/app/preferences',
        name: 'Preferences',
        component: () =>
            import('@/views/Preferences.vue')
    }, {
        path: '/app/InvestmentCalculator',
        name: 'InvestmentCalculator',
        component: () =>
            import('@/views/InvestmentCalculator.vue')
    },     {
        path: '/app/my-profile',
        name: 'MyProfile',
        component: () =>
            import('@/views/MyProfile.vue')
    },
    {
        path: '/app/referrals',
        name: 'Referrals',
        beforeEnter: requireActiveRole,
        component: () =>
            import('@/views/Referrals.vue')
    },
    {
        path: '/app/change-password',
        name: 'Password',
        component: () =>
            import('@/views/Password.vue')
    },
    {
        path: '/app/retrieve-password',
        name: 'Password',
        component: () =>
            import('@/views/RetrievePassword.vue')
    },
    {
        path: '/app/compoundInterestCalculator',
        name: 'Calculadora de interés compuesto',
        component: () =>
            import('@/views/CompoundInterestCalculator.vue')
    },
    {
        path: '/app/calculadora-autonomia-financiera',
        name: 'Calculadora de autonomía financiera',
        component: () =>
            import('@/views/RetirementCalculator.vue')
    },
    {
        path: '/app/inflationCalculator',
        name: 'Calculadora de inflación',
        component: () =>
            import('@/views/InflationCalculator.vue')
    },
    {
        path: '/app/calculadora-creador-cartera',
        name: 'Calculadora de cartera',
        component: () =>
            import('@/views/PortfolioCreatorCalculator.vue')
    }, {
        path: '/app/store',
        name: 'Tienda',
        component: () =>
            import('@/views/Store.vue')
    }, {
        path: '/app/cart',
        name: 'Cesta',
        component: () =>
            import('@/views/Cart.vue')
    }, {
        path: '/app/stock/:ticker',
        name: 'Valores',
        component: () =>
            import('@/views/Valores.vue')
    }, {
        path: '/app/portfolio/invest-preferences',
        name: 'InvestPreferences',
        beforeEnter: requirePortfolioAccess,
        component: () =>
            import('@/views/Portfolio_preferences.vue')
    }, {
        path: '/app/portfolio/balance/:idc',
        name: 'Portfolio Balance',
        beforeEnter: requirePortfolioAccess,
        component: () =>
            import('@/views/Portfolio_balance.vue')
    }, {
        path: '/app/portfolio/historic/:idc',
        name: 'Portfolio Historic',
        beforeEnter: requirePortfolioAccess,
        component: () =>
            import('@/views/Portfolio_historic.vue')
    }, {
        path: '/app/portfolio/general/:idc',
        name: 'Portfolio General',
        beforeEnter: requirePortfolioAccess,
        component: () =>
            import('@/views/Portfolio_general.vue')
    }, {
        path: '/app/portfolio/wait-list/:idc',
        name: 'Portfolio WaitList',
        beforeEnter: requirePortfolioAccess,
        component: () =>
            import('@/views/Portfolio_waitlist.vue')
    }, {
        path: '/app/portfolio/open-positions/:idc',
        name: 'Portfolio open Positions',
        beforeEnter: requirePortfolioAccess,
        component: () =>
            import('@/views/Portfolio_openpositions.vue')
    }, {
        path: '/app/portfolio-access-denied',
        name: 'PortfolioAccessDenied',
        beforeEnter: requireAuth,
        component: () =>
            import('@/views/PortfolioAccessDenied.vue')
    }, {
        path: '/app/videos',
        name: 'Videos',
        component: () =>
            import('@/views/Videos.vue')
    }, {
        path: '/app/profile/certificates/:uid?',
        name: 'UserCertificates',
        component: () =>
            import('@/views/Certificates.vue')
    }, {
        path: '/app/profile/user-photo',
        name: 'UserPhoto',
        component: () =>
            import('@/views/User-photo.vue')
    }, {
        path: '/app/profile/bills',
        name: 'UserBills',
        component: () =>
            import('@/views/Bills.vue')
    }, {
        path: '/app/nuevas-ipos',
        name: 'NewsIPOs',
        component: () =>
            import('@/views/News_ipos.vue')
    }, {
        path: '/app/crear-notificacion',
        name: 'CrearNotificacion',
        beforeEnter: checkAdminRights,
        component: () =>
            import('@/views/Crear_notificacion.vue')
    }, {
        path: '/app/session-control',
        name: 'SessionControl',
        beforeEnter: checkAdminRights,
        component: () =>
            import('@/views/Session_control.vue')
    }, {
        path: '/app/adminmenu',
        name: 'AdminMenu',
        beforeEnter: checkAdminRights,
        component: () =>
            import('@/views/AdminMenu.vue')
    }, {
        path: '/app/eventos',
        name: 'Eventos',
        beforeEnter: checkAdminRights,
        component: () =>
            import('@/views/Eventos.vue')
    }, {
        path: '/app/mentorias',
        name: 'Mentorias',
        beforeEnter: checkTutor,
        component: () =>
            import('@/views/Mentorias/Mentorias.vue')
    }, {
        path: '/app/mentorias/admin',
        name: 'Admin mentoring view',
        component: () =>
            import('@/views/Mentorias/Admin_mentorias.vue')
    }, {
        path: '/app/curso-online/login',
        name: 'Login Curso Online',
        component: () =>
            import('@/views/FakeLoginToCO.vue')
    }, {
        path: '/app/eurekers-school',
        name: 'Eurekers School',
        component: () =>
            import('@/views/EurekersSchool.vue')
    }, {
        path: '/app/user-register',
        name: 'Registro de Usuario',
        component: () =>
            import('@/views/RegisterForm.vue')
    }, {
        path: '/app/account-verification',
        name: 'Verificación de Cuenta',
        component: () =>
            import('@/views/AccountVerification.vue')
    }, {
        path: '/app/product-confirmation/gracias',
        name: 'Confirmacion de compra',
        component: () =>
            import('@/views/ProductConfirmation.vue')
    },
    {
        path: '/app/product-confirmation/error',
        name: 'Error de compra',
        component: () =>
            import('@/views/ProductConfirmationError.vue')
    },
    {
        path: '/app/course/register',
        name: 'Promo',
        component: () =>
            import('@/views/Promo.vue')
    },
    {
        path: '/app/store/course/form-waitlist/:country',
        name: 'Form Waitlist Courses',
        component: () =>
            import('@/views/Form_waitlist_courses.vue')
    },
    {
        path: '/app/informe/register',
        name: 'InformeFlow',
        component: () =>
            import('@/views/InformeFlow.vue')
    },
    {
        path: '/app/informe/subscribe',
        name: 'InformeSubscribe',
        component: () =>
            import('@/views/InformeSubscribe.vue')
    },
    {
         path: '/app/informes',
         name: 'informes',
         component: () => import('@/views/InformeMain.vue'),
         meta: {
             requiresAuth: true
         }
    },
    {
        path: '/app/noticias-flash/:slug?',
        name: 'NoticiasFlash',
        beforeEnter: requireNewsflashAdmin,
        component: () => import('@/views/NoticiasFlash.vue')
    },
    {
        path: '/app/informe/last',
        name: 'informe-last',
        beforeEnter: redirectToLastInforme,
        component: () => import('@/views/InformeDetail.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/app/informe/:title',
        name: 'informe-detail',
        component: () => import('@/views/InformeDetail.vue'),
        meta: {
            requiresAuth: true
        },
    },
    {
        path: '/app/libros-de-bolsa',
        name: 'LibrosBolsa',
        component: () =>
        import ('@/views/LibrosBolsa.vue')
    },
    {
        path: '/app/activo-resumen',
        name: 'LastMasterclass',
        beforeEnter: requireAuth,
        component: () =>
        import('@/views/LastMasterclass.vue')
    },
    {
        path: '/app/oldforum',
        name: 'OldForum',
        component: () =>
        import ('@/views/Foro.vue')
    },
    {
        path: '/app/forum',
        name: 'Forum',
        beforeEnter: requireActiveRole,
        component: () =>
        import ('@/views/newforum/index/NewForum.vue')
    },
    {
        path: '/app/forum/rules',
        name: 'ForumRules',
        beforeEnter: requireActiveRole,
        component: () =>
        import ('@/views/newforum/ForumRules.vue')
    },
    {
        path: '/app/forum/section/:slug',
        name: 'ForumSection',
        beforeEnter: requireActiveRole,
        component: ForumSection
    },
    {
        path: '/app/forum/thread/:nid',
        name: 'ForumThread',
        beforeEnter: requireActiveRole,
        component: () =>
        import ('@/views/newforum/thread/ForumThread.vue')
    },
    {
        path: '/app/forum/search',
        name: 'ForumSearch',
        beforeEnter: requireActiveRole,
        component: () =>
        import ('@/views/ForumSearch.vue')
    },
    {
        path: '/app/forum/new-thread',
        name: 'ForumNewThread',
        beforeEnter: requireActiveRole,
        component: NewThreadForm
    },
    {
    path: '/app/forum/user/activity',
    name: 'UserActivity',
    beforeEnter: requireActiveRole,
    component: () => import('@/views/newforum/user/UserActivity.vue')
  },
  {
    path: '/app/forum/admin/need-response',
    name: 'AdminNeedResponse',
    component: () => import('../views/newforum/admin/AdminNeedResponse.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    }
  },
  {
    path: '/app/forum/admin/reports',
    name: 'AdminReports',
    component: () => import('../views/newforum/admin/AdminReports.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    }
  },
  {
    path: '/app/forum/admin',
    name: 'AdminPanel',
    component: () => import('../views/newforum/admin/AdminPanel.vue'),
    meta: {
      requiresAuth: true,
      requiresAdmin: true
    }
  }
]

const router = new VueRouter({
    mode: 'history',
    routes
})
async function checkAdminRights(to, from, next) {
    let isAdmin = await _getUserInfo();
    isAdmin = isAdmin.data.is_developer_user;
    if (isAdmin) {
        next();
    } else {
        next({ path: '/app/graficador-dinamico' });
    }
}

async function checkLogged(to, from, next) {
    let isLogged = await _getUserInfo();
    //Esta comprobacion hace string con numero y da true cuando no debe por ser !== en vez de !=, por que lo sepas
    //No lo cambio porque tiene que ver con el login y el login va bien. Asi que asi se queda.
    isLogged = isLogged.data.uid !== 0;
    if (isLogged) {
        next({ path: '/app/login' });
    } else {
        next({ path: '/app/graficador-dinamico' });
    }
}

async function requireAuth(to, from, next) {
    try {
        let user = await _getUserInfo();
        let isLogged = user.data && user.data.uid && user.data.uid != 0;
        if (isLogged) {
            next();
        } else {
            next({ 
                path: '/app/login',
                query: { redirect: to.fullPath }
            });
        }
    } catch (error) {
        next({ 
            path: '/app/login',
            query: { redirect: to.fullPath }
        });
    }
}

async function requirePortfolioAccess(to, from, next) {
    try {
        let user = await _getUserInfo();
        let isLogged = user.data && user.data.uid && user.data.uid != 0;
        if (!isLogged) {
            next({ 
                path: '/app/login',
                query: { redirect: to.fullPath }
            });
            return;
        }

        if (user.data && user.data.is_basic_user) {
            next({ path: '/app/portfolio-access-denied' });
            return;
        }

        next();
    } catch (error) {
        next({ 
            path: '/app/login',
            query: { redirect: to.fullPath }
        });
    }
}

async function checkTutor(to, from, next) {
    let user = await _getUserInfo();
    if (user.data.uid == "8690") {
        next({ path: '/app/mentorias/admin' });
    } else {
        next();
    }
}

async function requireNewsflashAdmin(to, from, next) {
    try {
        let user = await _getUserInfo();
        let isLogged = user.data && user.data.uid && user.data.uid != 0;
        if (!isLogged) {
            next({
                path: '/app/login',
                query: { redirect: to.fullPath }
            });
            return;
        }

        let hasAdminAccess = !!(user.data.is_admin_user || user.data.is_developer_user);
        if (hasAdminAccess) {
            next();
        } else {
            next({ path: '/app/informes' });
        }
    } catch (error) {
        next({
            path: '/app/login',
            query: { redirect: to.fullPath }
        });
    }
}

async function requireActiveRole(to, from, next) {
    try {
        let user = await _getUserInfo();
        let isLogged = user.data && user.data.uid && user.data.uid != 0;
        if (!isLogged) {
            next({ 
                path: '/app/login',
                query: { redirect: to.fullPath }
            });
            return;
        }

        // Check if referrals is enabled for that route
        if (to.name === 'Referrals') {
            try {
                const settings = await _getReferralsSettings();
                if (!settings.data.enabled) {
                    next({ path: '/app' });
                    return;
                }
            } catch (err) {
                console.error('Error checking referrals settings', err);
                // Fallthrough to role check if check fails (or deny? deny is safer but maybe disruptive if api fails)
                // Let's deny if we can't verify it's enabled
                next({ path: '/app' });
                return;
            }
        }
        
        // Check if user has an active role (subscription)
        let userData = user.data;
        let hasActiveRole = userData.is_bronze_user || userData.is_silver_user || 
                           userData.is_gold_user || userData.is_platinum_user || 
                           userData.is_pre_user || userData.is_developer_user;
        
        if (hasActiveRole) {
            next();
        } else {
            next({ path: '/app/store' }); // Redirect to store to upgrade plan
        }
    } catch (error) {
        next({ path: '/app/login' });
    }
}

async function redirectToLastInforme(to, from, next) {
    try {
        const { data } = await axios.get(`${process.env.VUE_APP_API}/api/informes-list`);
        const informes = Array.isArray(data) ? data : [];

        if (!informes.length) {
            next({ path: '/app/informes' });
            return;
        }

        const latestInforme = informes.reduce((latest, current) => {
            const latestDate = _getInformeDate(latest);
            const currentDate = _getInformeDate(current);

            if (!currentDate && !latestDate) {
                return latest || current;
            }

            if (!latestDate) {
                return current;
            }

            if (!currentDate) {
                return latest;
            }

            return currentDate > latestDate ? current : latest;
        }, null);

        const targetInforme = latestInforme || informes[0];
        const slug = _buildInformeSlug(targetInforme);

        if (!slug) {
            next({ path: '/app/informes' });
            return;
        }

        next({
            path: `/app/informe/${slug}`,
            query: to.query,
            hash: to.hash
        });
    } catch (error) {
        next({ path: '/app/informes' });
    }
}

function _getInformeDate(informe) {
    if (!informe) {
        return null;
    }

    if (informe.created) {
        const createdDate = new Date(informe.created);
        if (!isNaN(createdDate.getTime())) {
            return createdDate;
        }
    }

    const title = typeof informe.title === 'string' ? informe.title : '';
    const match = title.match(/(\d{1,2})\/(\d{1,2})\/(\d{4})/);

    if (match) {
        const day = parseInt(match[1], 10);
        const month = parseInt(match[2], 10) - 1;
        const year = parseInt(match[3], 10);
        const date = new Date(year, month, day);
        if (!isNaN(date.getTime())) {
            return date;
        }
    }

    return null;
}

function _buildInformeSlug(informe) {
    if (!informe || typeof informe.title !== 'string') {
        return null;
    }

    const parts = informe.title.split('/');
    if (parts.length === 3) {
        return encodeURIComponent(`${parts[0]}-${parts[1]}-${parts[2]}`);
    }

    return encodeURIComponent(informe.title);
}

function _getUserInfo() {
    const uid = localStorage.getItem("uid") || 0;
    return axios.get(process.env.VUE_APP_API + "/api/v1/users/user-attributes/" + uid);
}

function _getReferralsSettings() {
    return axios.get(process.env.VUE_APP_API + "/api/v1/referrals/settings");
}
export default router
